import { dashboardApiV3 } from '#api';
import { FC, useEffect } from 'react';
import { b2bAccountTableHeaders } from '#globals';
import { useAppContext, useSafeState } from '#hooks';
import { B2bAccount } from '#types';
import { EditB2bAccount } from './editB2b.component';

export const B2bTable: FC = () => {

    const { setApiStatus } = useAppContext();
    const [isLoading, setIsLoading] = useSafeState<boolean>(true)
    const [b2bAccounts, setB2bAccounts] = useSafeState<B2bAccount[]>([]);
    const [b2bAccountToEdit, setB2bAccountToEdit] = useSafeState<B2bAccount | null>(null);

    const fetchB2bAccounts = async () => {
        try {
            const response = await dashboardApiV3.getB2bAccounts()
            setB2bAccounts([...response.data]);
        } catch (error: any) {
            setApiStatus({ code: error?.response?.data?.statusCode, message: error?.response?.data?.message })
        } finally {
            setIsLoading(false)
        }
    };

    useEffect(
        () => {
            fetchB2bAccounts();
        },
        []
    );


    if (isLoading) {
        return <div className="lds-hourglass" />
    }

    if (b2bAccountToEdit) {
        return <EditB2bAccount accountToEdit={b2bAccountToEdit} setAccountToEdit={setB2bAccountToEdit} />
    }

    return <div className='pd-m main-dashboard-container mt-s'>
        <table className='center-wrapper table'>
            <thead className="table-header">
                <tr>
                    {
                        b2bAccountTableHeaders.map(
                            (header: string) => <th className="table-cell" key={header}>{header.toUpperCase()}</th>
                        )
                    }
                </tr>
            </thead>
            <tbody>
                {
                    b2bAccounts.map(
                        (account: B2bAccount, index: number) => (
                            <tr key={`${account.nanoId}_${String(index)}`} className={'table-row'} onClick={() => setB2bAccountToEdit(account)}>
                                <td className="table-cell selectable-text">{account.nanoId}</td>
                                <td className="table-cell selectable-text">{account.name}</td>
                                <td className="table-cell selectable-text">{account.type}</td>
                                <td className="table-cell selectable-text">{account.owner?.email || 'unassigned'}</td>
                            </tr>
                        )
                    )
                }
            </tbody>
        </table>
    </div>
}
